import { QueryStringService } from '@amarkets/atlas/esm/lib/query-string';

export default function getAllQuery(url) {
  const [, partQuery] = url.split('?');

  return QueryStringService.parse({ query: partQuery });
}
